module.exports = __webpack_public_path__ + "img/no-active-stores.1d2d004f.png";